import { Pipe, PipeTransform } from '@angular/core';
import { InvoiceStatus } from '~core/models/invoice.models';

@Pipe({
  name: 'invoiceStatus',
  pure: true,
  standalone: true
})
export class InvoiceStatusPipe implements PipeTransform {
  private readonly _statusMap: Record<InvoiceStatus, string> = {
    [InvoiceStatus.draft]: 'Brouillon',
    [InvoiceStatus.processing]: 'En attente',
    [InvoiceStatus.validated]: 'En attente',
    [InvoiceStatus.certified]: 'Certifié',
    [InvoiceStatus.received]: 'Reçu',
    [InvoiceStatus.cancelled]: 'Annulé'
  };

  transform(status: InvoiceStatus | string): string {
    return this._statusMap[status as InvoiceStatus] || status;
  }
}
